import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import FactoryPhaseSupport from "./factory-phase-support.model";

export default class FactoryPhaseSupportFactory
  implements ObjectBuilderInterface<FactoryPhaseSupport> {
  public buildFromJSON(data: { [key: string]: any }): FactoryPhaseSupport {
    const value = new FactoryPhaseSupport(data.id, data.factory, data.slotType);

    (value as any).fCreatedAt = new Date(data.createdAt);
    (value as any).fUpdatedAt = new Date(data.updatedAt);

    value.isNew = false;

    return value;
  }
}
